import thirPartPayBg from "../../../assets/image/store/thridPayBgPink.jpg"; 
import thirPartPayBtnBg from "../../../assets/image/store/selectPayTypeIcon.png"; 
import selectPayTypeBtnBg from "../../../assets/image/store/selectPayTypeVgmBtnBg.png"; 
import whiteProductSwitchBtn from "../../../assets/image/store/product-change.png"; 
import bindIcon from "../../../assets/image/icons/bind-icon.png"; 
import showdetail from "../../../assets/image/icons/show-detail.png"; 
import userIcon from "../../../assets/image/icons/user-icon.png"; 
import officialPayIcon from "../../../assets/image/icons/fund-terms.png"; 
import ellipsisIcon from "../../../assets/image/icons/feedback-icon.png"; 
import textIcon from "../../../assets/image/icons/text-icon.png"; 
import accountFollowIcon from "../../../assets/image/icons/account-follow.png"; 
import exchangeIcon from "../../../assets/image/icons/exchange-icon.png"; 
import fundTermsIcon from "../../../assets/image/icons/fund-terms.png"; 
import deleteIcon from "../../../assets/image/icons/delete.png"; 
import survey from "../../../assets/image/icons/survey.png"; 
import settingIcon from "../../../assets/image/icons/setting-icon.png"; 
import loginBg from "../../../assets/image/webLogin/bg.jpg"; 
import langSelectIcon from "../../../assets/image/webLogin/tra.png"; 
import userName from "../../../assets/image/webLogin/account.png"; 
import password from "../../../assets/image/webLogin/password.png"; 
import helmet from "../../../assets/image/support/helmet.png"; 
import folder from "../../../assets/image/support/folder.png"; 
import serviceIcon from "../../../assets/image/support/potrait-service.png"; 
import userDefaultAvatar from "../../../assets/image/support/potrait-user.png"; 
import star from "../../../assets/image/support/star_hover-icon.png"; 
import supportChecked from "../../../assets/image/support/checked-icon.png"; 
import userInfoDefaultAvatar from "../../../assets/image/support/user-avatar.png"; 
import serviceInputIcon from "../../../assets/image/icons/service-input-icon.png"; 
import supportSearchIcon from "../../../assets/image/support/search.png"; 
import appleDeleteIcon from "../../../assets/image/icons/apple-delete.png"; 
import shortcutIcon from "../../../assets/image/icons/shortcut.png"; 
let $fillBtnVh = {
  'width' : '100%',
  'height' : '6.3vh',
  'line-height' : '6.3vh',
  'font-size' : '2.3vh'
}
let $lightGreen = '#5fd193'
let $middleGreen = '#57ae67'
let $passportFunctionIconStyles = {
  'background-repeat' : 'no-repeat',
  'width' : '78px',
  'height' : '95px',
  'background-position' : 'center center',
  'background-size' : 'auto !important'
}
let $activeListItem = {
  'border-color' : $middleGreen,
  'color' : $middleGreen
}

  export default {
'button' : { 
  commonTheme : {
  'font-size' : '32px',
  'height' : '60px',
  'line-height' : '60px',
  'color' : 'white',
  'background-color' : $lightGreen
  },
 typeTheme :{ 
 'fillLights' : { 
  'width' : '100%'
 
},
 'markScoreMainClose' : { 
  'background-color' : 'transparent'
 
},
 'long' : { 
  'width' : '456px'
 
},
 'short' : { 
  'width' : '300px'
 
},
 'edit' : { 
  'height' : '80px'
 
},
 'fill' : { 
  'width' : '100%',
  'background-color' : $middleGreen
 
},
 'refresh' : { 
  'background-color' : $middleGreen,
  'height' : '72px'
 
},
 'selectResetPwd' : { 
  'width' : '200px',
  'height' : '50px',
  'line-height' : '50px',
  'border-radius' : '0',
  'font-size' : '18px',
  'background-color' : $middleGreen
 
},
 'selectPayType' : { 
  'width' : '280px',
  'height' : '60px',
  'line-height' : '60px',
  'color' : '#b2161c',
  'margin-top' : '28px',
  'background-image' : `url( ${selectPayTypeBtnBg})`
 
},
 'switchProduct' : { 
  'background-image' : `url( ${whiteProductSwitchBtn})`,
  'width' : '56px',
  'height' : '56px',
  'background-color' : 'transparent',
  'border-radius' : '0'
 
},
 'reStore' : { 
  'background-color' : '#de6262'
 
},
 'swtichAccount' : { 
  'background-color' : 'transparent',
  'color' : '#57ae67',
  'height' : '60px',
  'line-height' : '18px',
  'font-size' : '15px'
 
},
 'lightShort' : { 
  'background' : '#57ae67',
  'height' : '72px',
  'line-height' : '72px',
  'font-size' : '20px'
 
},
 'closeBtn' : { 
  'height' : '24px',
  'width' : '24px',
  'font-size' : 'initial',
  'background-color' : 'transparent'
 
},
 'fillLight' : { 
  'width' : '100%',
  'background-color' : '#57ae67'
 
},
 'fillLightVh' : { 
  ...$fillBtnVh
 
},
 'fillEmtyBorderVh' : { 
  ...$fillBtnVh,
  'background-color' : 'transparent',
  'color' : '#5fd193'
 
},
 'shortCancel' : { 
  'background-color' : '#949494',
  'box-sizing' : 'border-box',
  'border' : '1px solid #a7a7a7',
  'height' : '54px',
  'line-height' : '54px',
  'font-size' : '20px'
 
},
 'shortConfirm' : { 
  'background-color' : '#57ae67',
  'box-sizing' : 'border-box',
  'border' : '1px solid #76bc83',
  'height' : '54px',
  'line-height' : '54px',
  'font-size' : '20px'
 
},
 'logoutBtn' : { 
  'height' : '4vh',
  'line-height' : '4vh',
  'font-size' : '1.8vh',
  'background' : 'hsla(0,0%,100%,.6)',
  'color' : '#7a7a7a'
 
},
 'shortWidth' : { 
  'background-color' : '#9588e4'
 
},
 'grayShort' : { 
  'background' : '#ccc',
  'height' : '72px',
  'line-height' : '72px'
 
}} 
}
,
'title' : { 
  commonTheme : {
  'color' : $middleGreen
  },
 typeTheme :{ 
 'payTitle' : { 
  'font-size' : ''
 
},
 'articleTtile' : { 
  'font-size' : '36px'
 
}} 
}
,
'headerContainer' : { 
  commonTheme : {
  'background' : '#f3f3f3'
  }}
,
'SelectGroup' : { 
  commonTheme : {
  'color' : '#57ae67',
  'border' : 'solid 1px #5fd193'
  },
 typeTheme :{ 
 'selectStoreInfo' : { 
  'box-sizing' : 'border-box',
  'display' : 'inline-block',
  'height' : '4.2vh',
  'border-radius' : '0',
  'padding' : '0 2vh',
  'background' : '#fff',
  'color' : '#666',
  'border-color' : 'rgb(169,169,169)',
  'margin-bottom' : '1.7vh'
 
}} 
}
,
'select' : { 
  commonTheme : {
  'color' : '#57ae67',
  'border' : 'solid 1px #5fd193'
  },
 typeTheme :{ 
 'selectLang' : { 
  'border' : '0',
  'color' : '#7a7a7a',
  'border-radius' : '4px'
 
},
 'selectLangLogin' : { 
  'border' : '0',
  'color' : '#7a7a7a',
  'border-radius' : '4px'
 
},
 'selectStoreInfo' : { 
  'box-sizing' : 'border-box',
  'display' : 'inline-block',
  'height' : '4.2vh',
  'border-radius' : '0',
  'padding' : '0 2vh',
  'background' : '#fff',
  'color' : '#666',
  'border-color' : 'rgb(169,169,169)',
  'margin-bottom' : '1.7vh'
 
},
 'selectProductOrder' : { 
  'color' : '#666',
  'border-color' : 'rgb(169,169,169)'
 
}} 
}
,
'add' : { 
  commonTheme : {
  'background-image' : 'url(data:image/png;base64,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)'
  }}
,
'supportReplyInput' : { 
  commonTheme : {
  'height' : '80px',
  'line-height' : '80px',
  'vertical-align' : 'top'
  }}
,
'icon' : { 

 typeTheme :{ 
 'searchType' : { 
  'background-image' : `url( ${supportSearchIcon})`,
  'width' : '25px',
  'height' : '26px'
 
},
 'select' : { 
  'background-image' : 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAYAAADJEc7MAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAmElEQVQY043QMQrCQBCF4X9FvEFukH57G0t7LUUG0u8B9AT2c4JFvISVoNhPnxvkBtvEZgOLkpiBad7jm2KcmDrgChyYNzfg6ADEdAXcgc0f9AC20YfkhkRMK+AN1COoBdbRhw7AlY2Y1hlXX6jLqB2CRdnmYgekIk7AvkQ/MOMX0AB93ib68Jz5OBDTk5iex/rlhL1MHf4A3hMoYMjpP7EAAAAASUVORK5CYII=);',
  'width' : '14px',
  'height' : '8px'
 
},
 'serviceInput' : { 
  'background-image' : `url( ${serviceInputIcon})`,
  'width' : '20px',
  'height' : '12px'
 
},
 'quessionSelect' : { 
  'border-top-color' : $middleGreen
 
},
 'bindIcon' : { 
  'background-image' : `url( ${bindIcon})`,
  ...$passportFunctionIconStyles
 
},
 'userIcon' : { 
  'background-image' : `url( ${userIcon})`,
  ...$passportFunctionIconStyles
 
},
 'ellipsisIcon' : { 
  'background-image' : `url( ${ellipsisIcon})`,
  ...$passportFunctionIconStyles
 
},
 'officialPayIcon' : { 
  'background-image' : `url( ${officialPayIcon})`,
  ...$passportFunctionIconStyles
 
},
 'textIcon' : { 
  'background-image' : `url( ${textIcon})`,
  ...$passportFunctionIconStyles
 
},
 'accountFollowIcon' : { 
  'background-image' : `url( ${accountFollowIcon})`,
  ...$passportFunctionIconStyles
 
},
 'exchangeIcon' : { 
  'background-image' : `url( ${exchangeIcon})`,
  ...$passportFunctionIconStyles
 
},
 'fundTermsIcon' : { 
  'background-image' : `url( ${fundTermsIcon})`,
  ...$passportFunctionIconStyles
 
},
 'survey' : { 
  'background-image' : `url( ${survey})`,
  ...$passportFunctionIconStyles
 
},
 'settingIcon' : { 
  'background-image' : `url( ${settingIcon})`,
  ...$passportFunctionIconStyles
 
},
 'deleteIcon' : { 
  'background-image' : `url( ${deleteIcon})`,
  ...$passportFunctionIconStyles
 
},
 'selectHili' : { 
  'background-image' : `url( ${showdetail})`,
  'background-repeat' : 'no-repeat',
  'width' : '11px',
  'height' : '18px'
 
},
 'selectvh' : { 
  'background-image' : `url( ${langSelectIcon})`,
  'background-repeat' : 'no-repeat',
  'background-size' : 'contain',
  'width' : '1.6vh',
  'height' : '1.2vh'
 
},
 'userName' : { 
  'background-image' : `url( ${userName})`,
  'width' : '2.1vh',
  'height' : '2.5vh',
  'background-repeat' : 'no-repeat',
  'background-size' : 'cover'
 
},
 'password' : { 
  'background-image' : `url( ${password})`,
  'width' : '1.9vh',
  'height' : '2.4vh',
  'background-repeat' : 'no-repeat',
  'background-size' : 'cover'
 
},
 'helmet' : { 
  'width' : '24px',
  'height' : '38px',
  'display' : 'inline-block',
  'background-image' : `url( ${helmet})`,
  'background-size' : 'contain',
  'vertical-align' : 'sub',
  'margin-right' : '10px'
 
},
 'folder' : { 
  'width' : '24px',
  'height' : '38px',
  'display' : 'inline-block',
  'background-size' : 'contain',
  'vertical-align' : 'sub',
  'margin-right' : '10px',
  'background-image' : `url( ${folder})`
 
},
 'serviceDefaultAvatar' : { 
  'background-image' : `url( ${serviceIcon})`
 
},
 'userDefaultAvatar' : { 
  'background-image' : `url( ${userDefaultAvatar})`
 
},
 'userInfoDefaultAvatar' : { 
  'background-image' : `url( ${userInfoDefaultAvatar})`
 
},
 'line' : { 
  'background-color' : '#5fd193'
 
},
 'custom' : { 
  'color' : '#5fd193'
 
},
 'selectThirPay' : { 
  'position' : 'absolute',
  'right' : '22px',
  'top' : '50%',
  'background-image' : `url( ${thirPartPayBtnBg})`,
  'width' : '16px',
  'height' : '17px',
  'transform' : 'translateY(-50%)'
 
},
 'thirdPartNameIconRight' : { 
  'display' : 'none'
 
},
 'appleDeleteIcon' : { 
  'background-image' : `url( ${appleDeleteIcon})`,
  ...$passportFunctionIconStyles
 
},
 'shortcutIcon' : { 
  'background-image' : `url( ${shortcutIcon})`,
  ...$passportFunctionIconStyles
 
}} 
}
,
'block' : { 

 typeTheme :{ 
 'funtionListItem' : { 
  'line-height' : '95px'
 
},
 'webLogin' : { 
  'background-image' : `url( ${loginBg})`,
  'background-position' : 'top center',
  'background-color' : '#89dcaf'
 
},
 'maintainScoreImg' : { 
  'display' : 'block',
  'width' : '158px',
  'height' : '158px',
  'margin' : '80px auto 20px auto',
  'background-image' : `url( ${supportChecked})`,
  'background-repeat' : 'no-repeat',
  'background-size' : 'cover'
 
}} 
}
,
'list' : { 

 typeTheme :{ 
 'passportFunctionList' : { 
  'float' : 'left'
 
}} 
}
,
'mark' : { 

 typeTheme :{ 
 'thirdPartName' : { 
  'color' : 'white'
 
},
 'amount' : { 
  'color' : '#de6263'
 
}} 
}
,
'listItem' : { 

 typeTheme :{ 
 'active' : { 
  ...$activeListItem
 
},
 'selectItem' : { 
  'border' : '1px solid #5fd193'
 
},
 'functionItem' : { 
  'height' : '95px',
  'padding-right' : '48px',
  'padding-left' : '76px',
  'display' : 'flex',
  'align-items' : 'center'
 
},
 'accountSettingItem' : { 
  'height' : '95px',
  'display' : 'flex',
  'align-items' : 'center'
 
},
 'locationItem' : { 
  'height' : '80px'
 
},
 'productSelectOptions' : { 
  'text-align' : 'left'
 
},
 'paymentItem' : { 
  'height' : '80px'
 
}} 
}
,
'thirPartPay' : { 
  commonTheme : {
  'background-image' : `url( ${thirPartPayBg})`
  }}
,
'selectTriggerBtn' : { 

 typeTheme :{ 
 'amountSelect' : { 
  'float' : 'right'
 
}} 
}
,
'scoreStart' : { 

 typeTheme :{ 
 'active' : { 
  'background-image' : `url( ${star})`,
  'background-repeat' : 'no-repeat'
 
}} 
}

}